<template>
  <Teleport to="body">
    <div v-if="visible" class="modal-overlay" @click="closeModal">
      <div class="modal" @click.stop>
        <h3>驳回文章</h3>
        <p class="modal-desc">请输入驳回原因，将会通过邮件发送给作者。</p>
        <textarea 
          v-model="rejectReason" 
          class="reject-textarea" 
          placeholder="请输入驳回原因..."
          rows="5"
        ></textarea>
        <div class="modal-actions">
          <button @click="closeModal" class="cancel-btn">取消</button>
          <button @click="submitReject" class="confirm-btn danger-btn" :disabled="!rejectReason.trim() || isRejecting">
            {{ isRejecting ? '提交中...' : '确认驳回' }}
          </button>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script>
import eventBus from '@/utils/eventBus'

export default {
  name: 'RejectModal',
  data() {
    return {
      visible: false,
      rejectReason: '',
      isRejecting: false,
      resolvePromise: null,
      rejectPromise: null
    }
  },
  methods: {
    open() {
      this.rejectReason = ''
      this.isRejecting = false
      this.visible = true
      return new Promise((resolve, reject) => {
        this.resolvePromise = resolve
        this.rejectPromise = reject
      })
    },
    closeModal() {
      this.visible = false
      if (this.rejectPromise) {
        this.rejectPromise(new Error('User cancelled reject'))
        this.resetPromise()
      }
    },
    submitReject() {
      if (!this.rejectReason.trim()) {
        this.$message?.warning('请输入驳回原因')
        return
      }
      this.isRejecting = true
      if (this.resolvePromise) {
        this.resolvePromise(this.rejectReason)
      }
      // Visible is not set to false here so the caller can handle loading state.
    },
    close() {
        this.visible = false;
        this.resetPromise()
    },
    resetPromise() {
        this.resolvePromise = null;
        this.rejectPromise = null;
    }
  },
  mounted() {
    eventBus.on('show-reject-modal', (params) => {
      // Use callback to resolve the reject submission
      this.open().then((reason) => {
          if(params && params.onSubmit) {
              params.onSubmit(reason, this) // Pass instance to allow closing when done
          }
      }).catch(() => {
          // Cancelled
          if(params && params.onCancel) {
              params.onCancel()
          }
      })
    })
  },
  beforeUnmount() {
    eventBus.off('show-reject-modal')
  }
}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: var(--z-modal);

}

.modal {
  background: white;
  border-radius: 16px;
  padding: 24px;
  width: 400px;
  max-width: 90%;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
  animation: modalSlideIn 0.3s ease;
}

.modal h3 {
  margin: 0 0 10px 0;
  color: #2d3436;
  font-size: 18px;
}

.modal-desc {
  color: #636e72;
  font-size: 14px;
  margin-bottom: 15px;
}

.reject-textarea {
  width: calc(100% - 24px);
  padding: 12px;
  border: 1px solid #dfe6e9;
  border-radius: 8px;
  resize: vertical;
  min-height: 100px;
  font-size: 14px;
  margin-bottom: 20px;
  transition: border-color 0.3s;
  outline: none;
  font-family: inherit;
}

.reject-textarea:focus {
  border-color: #ff4757;
}

.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

.cancel-btn {
  padding: 8px 20px;
  border: 1px solid #dfe6e9;
  background: white;
  color: #636e72;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s;
}

.cancel-btn:hover {
  background: #f1f2f6;
}

.confirm-btn {
  padding: 8px 20px;
  border: none;
  color: white;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s;
}

.danger-btn {
  background: #ff4757;
}

.danger-btn:hover {
  background: #ff6b81;
}

.danger-btn:disabled {
  background: #ffb8b8;
  cursor: not-allowed;
}

@keyframes modalSlideIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Dark theme support */
.dark-theme .modal {
  background: #2d3436;
}

.dark-theme .modal h3 {
  color: #dfe6e9;
}

.dark-theme .modal-desc {
  color: #b2bec3;
}

.dark-theme .reject-textarea {
  background: #1e272e;
  border-color: #4b6584;
  color: #dfe6e9;
}

.dark-theme .cancel-btn {
  background: transparent;
  border-color: #4b6584;
  color: #b2bec3;
}

.dark-theme .cancel-btn:hover {
  background: rgba(255, 255, 255, 0.05);
}
</style>
